import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Select,
  FormControl,
  MenuItem,
  Switch,
  IconButton,
  CircularProgress,
  Modal,
  InputAdornment,
  Tooltip
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import PriceAdjuster from "./Priceadjuster";
import LoanDetails from "./loandetails";
import { KeyboardArrowLeftOutlined } from "@mui/icons-material";
import Loaninfo from "./loaninfo";
import Repayment from "./repayment";
import { endLoading, startLoading } from "../../../Redux/loadingSlice";
import { usePaymentMethods } from '../../../hooks/usePaymentMethods';
import Axios from "../../../config/axios";
import { UrlConstant } from "../../../commom/UrlConstant";
import { getUserFromLocalStorage } from "../../../utils/utils";
import OrderSuccessPopup from "../Popups/OrderSuccessPopup";
import moment from "moment";
import Successpopup from "../SharedComponent/Successpopup";
import OtpInput from "react-otp-input";
import BoosterLoanReminderModal from '../Popups/BoosterLoanReminderModal';
import { keyframes } from '@mui/system';
import buySellBg from '../../../commom/Assets/images/buy-sell-bg.png';
import thunderIcon from '../../../commom/Assets/images/thunder.png';
import { usePriceFormatter } from '../../../hooks';
import { AssetType } from "../../../types/formatting";
import { formatPercentage } from "../../../utils/formatting";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { trackEvent } from "../../../config/firebase";
import { Constant } from "../../../commom/Constants";

function BuySell({ stockDetail, tickerData, tickerDataAll, icon, tradType, assetType, c2cTradable }: any) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // Subtle, professional icon animations
  const floatY = keyframes`
    0% { transform: translateY(0); }
    50% { transform: translateY(-2px); }
    100% { transform: translateY(0); }
  `;
  const pulseGlow = keyframes`
    0% { transform: scale(0.9); opacity: 0.25; }
    50% { transform: scale(1.05); opacity: 0.5; }
    100% { transform: scale(0.9); opacity: 0.25; }
  `;
  const bounceJump = keyframes`
    0% { transform: translateY(0) scale(1); }
    20% { transform: translateY(-8px) scale(1.03); }
    40% { transform: translateY(0) scale(1); }
    55% { transform: translateY(-4px) scale(1.01); }
    70% { transform: translateY(0) scale(1); }
    100% { transform: translateY(0) scale(1); }
  `;
  const flashRing = keyframes`
    0% { transform: scale(0.6); opacity: 0; }
    25% { transform: scale(1); opacity: 0.45; }
    60% { transform: scale(1.25); opacity: 0.15; }
    100% { transform: scale(1.4); opacity: 0; }
  `;

  const buyButtonRef = useRef<any>(null);
  const sellButtonRef = useRef<any>(null);
  const [isBuyActive, setIsBuyActive] = useState<any>(tradType === "Buy" ? true : false);
  const [isSellActive, setIsSellActive] = useState<any>(tradType === "Sell" ? true : false);
  const [selection, setSelectedRatio] = React.useState<String>("");
  const [selectLimit, setSelectLimit] = React.useState<String>('Market');
  const [IsOnBoosterLoan, setOnBoosterLoan] = useState<boolean>(false);
  const [isLoaninfo, setIsLoaninfo] = useState<boolean>(false);
  const [ispayment, setIspayment] = useState<boolean>(false);
  const [tradingInfo, setTradingInfo] = useState<any>();
  const [stockQty, setStockQty] = useState<any>(0);
  const [estimatedAmount, setEstimatedAmount] = useState<any>(0);
  const [limitPrice, setLimitPrice] = useState<any>(0);
  const [boosterLoanDetails, setBoosterLoanDetails] = useState<any>();
  const [loanAmountData, setLoanAmountData] = useState<any>();
  const [loanElogibilityData, setLoanEligibilityData] = useState<any>();
  const [boosterLoading, setBoosterLoading] = useState<any>(false)
  const [loanAmount, setLoanAmount] = React.useState<number>();
  const [recalculate, setRecalculate] = React.useState<boolean>(false);
  const [acceptCondition, setacceptCondition] = React.useState<boolean>(false);
  const { paymentMethods, fetchAllPaymentMethods, selectedPaymentMethod, setSelectedPaymentMethod } = usePaymentMethods();
  const [availabelQty, setAvailabelQty] = React.useState<any>(0);
  const [popupOpen, setPopupOpen] = useState(false);
  const [orderDetails, setOrderDetails] = useState<any>();
  const [showPopup, setShowPopup] = useState(false); // State for controlling popup visibility
  const [msg, setmsg] = useState(''); // State for controlling popup visibility
  const [Success, setSuccess] = useState(false); // State for controlling popup visibility
  const [heading, setheading] = useState(''); // State for controlling popup visibility
  const [loading, setLoading] = useState(false);
  const [isAchHoldActive, setIsAchHoldActive] = useState(false);

  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [cryptoOrderId, setCryptoOrderId] = useState("");
  const [boosterLoanReminderOpen, setBoosterLoanReminderOpen] = useState(false);
  const [dontRemind30Days, setDontRemind30Days] = useState(false);
  const [pendingOrderType, setPendingOrderType] = useState<string | null>(null);
  const [cryptoLoanData, setCryptoLoanData] = useState<any>(null);
  const [remainingLoanQuantity, setRemainingLoanQuantity] = useState<number>(0);
  const [toolTipAmount, setToolTipAmount] = useState<number>(0);
  const decimalsMap = {
    crypto: 8,
    stock: 2,
    default: 2
  };

  // Initialize formatter with currency from Redux
  const formatter = usePriceFormatter();

  const currencyInfo = useAppSelector((state) => state.currency);

  const decimals = decimalsMap[assetType] ?? decimalsMap.default;

  const user = getUserFromLocalStorage();

  // const userCountry = (user?.country || "").trim().toLowerCase();
  // const isAustralian = userCountry === "au";
  // const isC2CRestricted = isAustralian && !c2cTradable;

  // Helper function to check if "don't remind for 30 days" is set
  const shouldShowBoosterLoanReminder = (): boolean => {
    try {
      const reminderData = localStorage.getItem('boosterLoanReminderDismissed');
      if (!reminderData) return true;

      const { expiryDate } = JSON.parse(reminderData);
      const now = Date.now();

      // If expiry date has passed, remove the flag and show reminder
      if (now > expiryDate) {
        localStorage.removeItem('boosterLoanReminderDismissed');
        return true;
      }

      return false; // Still within 30 days, don't show
    } catch (error) {
      return true; // On error, show the reminder
    }
  };

  // Helper function to save "don't remind for 30 days" preference
  const saveDontRemindPreference = () => {
    const expiryDate = Date.now() + (30 * 24 * 60 * 60 * 1000); // 30 days from now
    localStorage.setItem('boosterLoanReminderDismissed', JSON.stringify({ expiryDate }));
  };

  // Debounced, minimum-duration global loader for initial/page-level fetches
  const uiPendingRequests = useRef<number>(0);
  const loaderShownAt = useRef<number>(0);
  const hideTimerId = useRef<any>(null);
  const beginUILoading = () => {
    if (uiPendingRequests.current === 0) {
      if (hideTimerId.current) {
        clearTimeout(hideTimerId.current);
        hideTimerId.current = null;
      }
      loaderShownAt.current = Date.now();
      dispatch(startLoading());
      setLoading(true);
    }
    uiPendingRequests.current += 1;
  };
  const endUILoading = () => {
    uiPendingRequests.current = Math.max(0, uiPendingRequests.current - 1);
    if (uiPendingRequests.current === 0) {
      const minDurationMs = 500; // minimum visible time
      const debounceMs = 150; // avoid flicker between rapid sequences
      const elapsed = Date.now() - loaderShownAt.current;
      const delay = Math.max(minDurationMs - elapsed, debounceMs, 0);
      hideTimerId.current = setTimeout(() => {
        dispatch(endLoading());
        setLoading(false);
        hideTimerId.current = null;
      }, delay);
    }
  };

  // Reference-counted side loader for booster loan panel
  const boosterSidePending = useRef<number>(0);
  const beginBoosterSideLoading = () => {
    if (boosterSidePending.current === 0) {
      setBoosterLoading(true);
    }
    boosterSidePending.current += 1;
  };
  const endBoosterSideLoading = () => {
    boosterSidePending.current = Math.max(0, boosterSidePending.current - 1);
    if (boosterSidePending.current === 0) {
      setBoosterLoading(false);
    }
  };

  const resolvePaymentMethodId = (method: any): string | null => {
    if (!method) return null;
    const id =
      method.id ??
      method.customerPaymentProfileId ??
      method?.rawData?.customerPaymentProfileId ??
      method?.rawData?.id;
    return id !== undefined && id !== null ? String(id) : null;
  };

  const resolveBoosterLoanId = (): string | null => {
    const candidates = [
      boosterLoanDetails?.loanDetail?.id,
      boosterLoanDetails?.loan?.id,
      boosterLoanDetails?.loan_id,
      boosterLoanDetails?.loanId,
      loanAmountData?.loanDetail?.id,
      loanAmountData?.loan?.id,
      loanAmountData?.loanId,
      user?.boosterloan_id,
    ];
    const found = candidates?.find?.(
      (value) => value !== undefined && value !== null && value !== ''
    );
    return found !== undefined ? String(found) : null;
  };

  const handleLoanPaymentMethodChange = async (method: any) => {
    setSelectedPaymentMethod(method);

    const loanId = resolveBoosterLoanId();

    const { id, type } = method;
    if (!id || !type || !loanId) {
      console.error('Missing required data for payment method change');
      return;
    }

    beginUILoading();

    try {
      const response = await Axios.post(
        UrlConstant.BoosterLoan.UpdatePaymentMethod,
        null,
        {
          params: {
            loanId,
            customerPaymentProfileId: id,
            paymentMethodType: type,
          },
        }
      );

      if (!response.data?.status) {
        setheading('Error');
        setSuccess(false);
        setShowPopup(true);
        setmsg(response.data?.message || 'Failed to update payment method.');
      }
    } catch (error: any) {
      console.error('Error updating booster loan payment method:', error);
      setheading('Error');
      setSuccess(false);
      setShowPopup(true);
      setmsg(error?.response?.data?.message || 'Failed to update payment method.');
    } finally {
      endUILoading();
    }
  };

  const handleselect = (
    newselection: string
  ) => {
    setSelectedRatio(newselection);
    onChangeRatio(newselection, { fromRatio: true })
  };

  const handleBuyClick = () => {
    setIsBuyActive(true); // Activate Buy button and deactivate Sell button
    setIsSellActive(false); // Activate Buy button and deactivate Sell button
    setSelectedRatio("");
  };

  const handleinfo = () => {
    setIsLoaninfo(!isLoaninfo)
  };

  const handlepayment = () => {
    setIspayment(!ispayment)
  };

  const handleSellClick = () => {
    setIsSellActive(true); // Activate Sell button and deactivate Buy button
    setIsBuyActive(false); // Activate Sell button and deactivate Buy button
    setSelectedRatio("");
  };

  const handleChange = (e) => {
    setLimitPrice(tickerData?.lastPrice)
    setSelectLimit(e.target.value);
  };

  const handleswitch = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const balance = tradingInfo?.BuyingPower?.AvailableFunds || 0;
      const { error } = validateOrder("Buy", balance);
      if (error) {
        setheading("Error");
        setShowPopup(true);
        setmsg(error);
        return;
      }
      if (Constant.ENV === "production") {
        trackEvent("booster_loan_viewed", {
          source: `Symbol: ${stockDetail?.symbol},
      AssetType: ${assetType},`
        });
      }
      setBoosterLoading(true);
    }
    setOnBoosterLoan(isChecked);
  };

  const fetchCryptoLoan = async () => {
    try {
      const response = await Axios.get(UrlConstant.Crypto.GetCryptoLoan);
      const loanData = response?.data?.data || {};
      setCryptoLoanData(loanData);
      return loanData;
    } catch (error: any) {
      console.error("Crypto loan error : ", error);
      setCryptoLoanData(null);
      return null;
    }
  };

  const fetchTradingBalance = async () => {
    beginUILoading();

    try {
      let tradingData: any = null;

      if (assetType === 'crypto') {
        // --- Fetch crypto balance ---
        const response = await Axios.get(UrlConstant.User.GetUserBalance);
        const balanceList = Array.isArray(response.data.data.balances) ? response.data.data.balances : [];
        const currency = currencyInfo.code.toLowerCase() || 'usd';
        const fiatObj = balanceList.find(item => item.currency === currency);

        tradingData = {
          BuyingPower: {
            AvailableFunds: Number(fiatObj.available) ?? 0,
          },
        };
        // --- Fetch crypto quantity ---
        const baseCurrency = stockDetail?.currency_pair
          ? stockDetail.currency_pair.replace(/usd$/i, '').toLowerCase()
          : null;
        const tokenObj = baseCurrency
          ? balanceList.find(
            item =>
              item.currency != null &&
              (
                item.currency.toLowerCase() === `${baseCurrency}usd` ||
                item.currency.toLowerCase() === baseCurrency
              )
          )
          : null;
        setAvailabelQty(Number(tokenObj?.available) ?? 0);
        if (!tokenObj?.available) {
          setIsSellActive(false)
          setIsBuyActive(true)
        }
        // --- Fetch crypto loan data ---
        await fetchCryptoLoan();
      } else {
        // --- Fetch stock balance ---
        if (!user?.tradingblock_application_id) {
          return; // no account → nothing to fetch
        }

        const payload = { accountId: user.tradingblock_application_id };
        const { data } = await Axios.post(UrlConstant.BuySell.GetTradingBalance, payload);

        tradingData = data?.data?.Payload ?? null;
      }

      if (tradingData) {
        setTradingInfo(tradingData);
      } else {
        throw new Error("No trading balance data returned");
      }
    } catch (error: any) {
      console.error("[fetchTradingBalance] Error:", error);

      setheading("Error");
      setmsg(error.response?.data?.message || "An error occurred while fetching balance.");
      setShowPopup(true);
    } finally {
      endUILoading();
    }
  };

  const fetchBoosterLoanData = async () => {
    // check-trading-balance
    beginUILoading();
    try {
      const response = await Axios.get(
        UrlConstant.BoosterLoan.CheckBoosterLoan.replace("{0}", stockDetail?.symbol))

      setBoosterLoanDetails(response.data?.data)
    } catch (error: any) {
      console.error("ERRR : ", error);
      // Swal.fire('Error', error.response?.data?.message || "An error occurred.", 'error')
      setheading('Error')
      setShowPopup(true)
      setmsg(error.response?.data?.message || "An error occurred.")

    } finally {
      endUILoading();
    }
  }

  const fetchLoanEligibility = async (showGlobal: boolean = false) => {
    beginBoosterSideLoading()
    if (showGlobal) beginUILoading();
    const data = {
      "symbol": stockDetail?.symbol,
      "stockAmount": +estimatedAmount
    }

    try {
      const response = await Axios.post(
        UrlConstant.BoosterLoan.CheckBoosterEligibility, data)
      setLoanEligibilityData(response.data?.data)
      setLoanAmountData(response.data?.data)
    } catch (error: any) {
      console.error("ERRR : ", error);
      // Swal.fire('Error', error.response?.data?.message || "An error occurred.", 'error')
      setheading('Error')
      setShowPopup(true)
      setmsg(error.response?.data?.message || "An error occurred.")

      setOnBoosterLoan(false)
    } finally {
      endBoosterSideLoading()
      if (showGlobal) endUILoading();
    }
  }
  const fetchLoanAmount = async (amount: any, showGlobal: boolean = false) => {
    // check-trading-balance
    beginBoosterSideLoading()
    if (showGlobal) beginUILoading();
    const amountData = amount ?? estimatedAmount
    const offer = loanElogibilityData?.offer?.id
    try {
      const response = await Axios.get(
        UrlConstant.BoosterLoan.GetLoanAmount.replace("{0}", amountData).replace("{1}", offer))

      setLoanAmountData(response.data?.data)
    } catch (error: any) {
      console.error("ERRR : ", error);
      // Swal.fire('Error', error.response?.data?.message || "An error occurred.", 'error')
      setheading('Error')
      setShowPopup(true)
      setmsg(error.response?.data?.message || "An error occurred.")
    } finally {
      endBoosterSideLoading()
      if (showGlobal) endUILoading();
    }
  }

  // const fetchAvailbleQty = async () => {
  //   beginUILoading();
  //   const data = {
  //     "accountId": user?.tradingblock_application_id
  //   }
  //   try {
  //     const response = await Axios.post(
  //       UrlConstant.BuySell.AvailbleQty.replace("{symbol}", stockDetail?.symbol), data)
  //     if (response.data?.data) {
  //       setAvailabelQty(Number(response.data?.data.quantity) || 0)
  //     }
  //   } catch (error: any) {
  //     console.error("ERRR : ", error);
  //     // Swal.fire('Error', error.response?.data?.message || "An error occurred.", 'error')
  //     setheading('Error')
  //     setShowPopup(true)
  //     setmsg(error.response?.data?.message || "An error occurred.")
  //   } finally {
  //     endUILoading();
  //   }
  // }

  const onRecalculate = async () => {
    await fetchLoanAmount(loanAmount)
    setRecalculate(false);
  };

  //Buy now Action

  // const onBuyNow = async () => {
  //   dispatch(startLoading());
  //   if (IsOnBoosterLoan && !acceptCondition) {
  //     alert("accept the loan condtions")
  //     return
  //   }
  //   const data = {
  //     "symbol": stockDetail?.symbol,
  //     "quantity": Number(stockQty),
  //     "accountId": user?.tradingblock_application_id,
  //     "type": "Buy",
  //     "orderType": selectLimit,
  //     "price": Number(tickerData?.lastPrice),
  //     "loanPrice": Number(IsOnBoosterLoan ? loanAmount : 0),
  //     "loanQuantity": Number(IsOnBoosterLoan ? stockQty : 0)
  //   }

  //   try {
  //     const response = await Axios.post(
  //       UrlConstant.BuySell.PlaceBuyOrderFake, data)
  //     console.log(response, "response")
  //   } catch (error: any) {
  //     console.error("ERRR : ", error);
  //   } finally {
  //     dispatch(endLoading());
  //   }
  // }
  const validateOrder = (
    orderType: "Buy" | "Sell",
    balance: number
  ): { error: string | null; autoEnableLoan: boolean } => {
    if (!estimatedAmount || isNaN(Number(estimatedAmount)) || Number(estimatedAmount) <= 0) {
      return { error: "Please enter a valid amount", autoEnableLoan: false };
    }

    if (
      orderType === "Buy" &&
      assetType === "crypto" &&
      isAchHoldActive
    ) {
      const holdDate = new Date(user.achHold);
      const formattedDate = holdDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      if (stockDetail.isLoanMandatory) {
        return {
          error: `This asset requires a loan, but your recent ACH deposit is still on hold until ${formattedDate}. It typically takes 4–5 business days for funds to clear. You can place a loan order after the hold period ends.`,
          autoEnableLoan: false,
        };
      }

      if (IsOnBoosterLoan) {
        return {
          error: `Your recent ACH deposit is still on hold until ${formattedDate}. You can still place a regular buy order without using a loan.`,
          autoEnableLoan: false,
        };
      }
    }

    if (IsOnBoosterLoan && !acceptCondition) {
      return { error: "Accept the loan conditions", autoEnableLoan: false };
    }

    if (orderType === "Sell" && Number(stockQty) > availabelQty) {
      return { error: "You have exceeded the maximum available quantity", autoEnableLoan: false };
    }

    if (orderType === "Buy" && Number(estimatedAmount) > balance) {
      return { error: "You don't have enough Balance", autoEnableLoan: false };
    }

    // Auto-enable loan case
    if (orderType === "Buy" && assetType === "crypto" && stockDetail.isLoanMandatory) {
      return { error: null, autoEnableLoan: true };
    }

    return { error: null, autoEnableLoan: false };
  };

  // Stock buy function
  const stockBuy = async (orderType: string) => {
    dispatch(startLoading());
    setLoading(true);
    const baseData = {
      symbol: stockDetail?.symbol,
      quantity: Number(stockQty),
      accountId: user?.tradingblock_application_id,
      type: orderType,
      orderType: selectLimit,
    };
    const payload = selectLimit === "Market" ? { ...baseData } : { ...baseData, price: limitPrice };
    try {
      const response = await Axios.post(UrlConstant.BuySell.PlaceBuyOrder, payload);
      setPopupOpen(true);
      const displayAmount =
        orderType === "Sell"
          ? (Number(stockQty) * (tickerData?.lastPrice || 0))
          : estimatedAmount;
      const orderDetails = {
        symbol: stockDetail?.symbol,
        stockName: stockDetail?.displayName,
        orderId: response.data?.data?.Payload?.OrderId,
        dateTime: moment().format("MM/DD/YYYY hh:mm A"),
        totalQty: stockQty,
        totalAmount: displayAmount,
      };
      setOrderDetails(orderDetails);
      setEstimatedAmount(0);
      setStockQty(0);
      await fetchTradingBalance();
      // fetchAvailbleQty();
    } catch (error: any) {
      setheading('Error');
      setShowPopup(true);
      setmsg(error.response?.data?.message[0] || "An error occurred.");
    } finally {
      dispatch(endLoading());
      setLoading(false);
    }
  };

  // Crypto Order function
  const cryptoOrder = async (orderType: "Buy" | "Sell") => {
    setLoading(true);

    let payload: any;
    let endpoint = "";

    if (orderType === "Buy") {
      payload = {
        price: tickerData?.lastPrice || 0,
        type: "DIRECT",
        currencyPair: stockDetail.currency_pair,
        amount: estimatedAmount,
        customerPaymentProfileId: selectedPaymentMethod?.id || null,
        customerPaymentProfileType: selectedPaymentMethod?.type || null,
      };

      if (IsOnBoosterLoan) {
        payload.type = "LOAN";
        payload.loanAmount =
          loanAmount || loanElogibilityData?.offer?.offerPrice;
      }

      endpoint = UrlConstant.Crypto.PlaceBuyOrder;
    } else {
      payload = {
        currencyPair: stockDetail.currency_pair,
        amount: estimatedAmount,
        quantity: stockQty,
      };

      endpoint = UrlConstant.Crypto.PlaceSellOrder;
    }

    try {
      const { data: resData } = await Axios.post(endpoint, payload);

      if (resData?.status !== "success") {
        setShowPopup(true);
        setmsg(resData?.message || "An error occurred.");
        return;
      }

      const apiData = resData?.data

      if (!apiData?.orders?.length) {
        setShowPopup(true);
        setmsg("Invalid response from server.");
        return;
      }

      const orderDetails = {
        symbol: stockDetail?.symbol,
        stockName: stockDetail?.displayName,
        side: orderType,
        isSplit: apiData.isSplit,
        orders: apiData.orders,
        summary: apiData.summary,
        partialFailure: apiData.partialFailure,
        failedSegments: apiData.failedSegments,
        dateTime: moment().format("MM/DD/YYYY hh:mm A"),
      };

      if (orderType === "Buy" && IsOnBoosterLoan) {
        if (Constant.ENV === "production") {
          trackEvent("booster_loan_started", {
            source: `Symbol: ${stockDetail?.symbol},
          AssetType: ${assetType},
          loan Amount: ${loanAmount || loanElogibilityData?.offer?.offerPrice},`
          });
        }
      }

      setOrderDetails(orderDetails);
      setPopupOpen(true);

      await fetchTradingBalance();
      setEstimatedAmount(0);
      setSelectedRatio("");
      setStockQty(0);
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";
      setShowPopup(true);
      setmsg(errorMsg);
    } finally {
      setLoading(false);
    }
  };


  // OTP submit handler
  const handleOtpSubmit = async () => {
    if (otp.length !== 6) {
      setOtpError("Please enter a 6-digit OTP.");
      return;
    }
    setOtpLoading(true);
    setOtpError("");
    try {
      const payload = {
        orderId: cryptoOrderId,
        otpCode: otp,
      };
      const response = await Axios.post(UrlConstant.Crypto.VerifyTransfer, payload);
      const data = response.data;
      const currentPrice = tickerData?.lastPrice ?? 0;
      const usrQty = currentPrice > 0 ? Number(estimatedAmount) / currentPrice : 0;
      const loanQty = currentPrice > 0 ? Number(loanAmountData?.offer?.offerPrice || 0) / currentPrice : 0;
      const totalQty = usrQty + loanQty;
      const totalAmount = Number(estimatedAmount) + Number(loanAmountData?.offer?.offerPrice || 0);
      if (data.success) {
        const orderDetails = {
          symbol: stockDetail?.symbol,
          stockName: stockDetail?.displayName,
          orderId: data.order.orderId,
          dateTime: moment().format("MM/DD/YYYY hh:mm A"),
          totalQty,
          totalAmount,
        };

        setOrderDetails(orderDetails);
        await fetchTradingBalance();
        setPopupOpen(true);
        setOtpModalOpen(false);
        setOnBoosterLoan(false)
        setOtp("");
      } else {
        setOtpError(data.error || "Invalid OTP.");
      }
    } catch (error: any) {
      setOtpError(error.response?.data?.error || "An error occurred.");
    } finally {
      setOtp("");
      setOtpLoading(false);
    }
  };

  const resendOTP = async () => {
    setOtp("");
    setOtpError("");
    setOtpLoading(true);

    try {
      const payload = { orderId: cryptoOrderId };
      const response = await Axios.post(UrlConstant.Crypto.ResendConfirmation, payload);
      const data = response.data;

      if (data.success) {
        setOtpError("OTP resent successfully.");
      } else {
        setOtpError(data.error || "Failed to resend OTP.");
      }
    } catch (error: any) {
      setOtpError(error.response?.data?.error || "An error occurred while resending OTP.");
    } finally {
      setOtpLoading(false);
    }
  };


  const onBuyNow = async (orderType: any) => {
    const balance = tradingInfo?.BuyingPower?.AvailableFunds || 0;
    const { error, autoEnableLoan } = validateOrder(orderType, balance);
    if (error) {
      setheading("Error");
      setShowPopup(true);
      setmsg(error);
      return;
    }

    // Check if booster loan is available but not enabled, and user is buying (BEFORE autoEnableLoan check)
    const isBoosterLoanAvailable = (boosterLoanDetails?.isEligible);
    if (orderType === "Buy" && isBoosterLoanAvailable && !IsOnBoosterLoan && !autoEnableLoan && shouldShowBoosterLoanReminder()) {
      setPendingOrderType(orderType);
      setBoosterLoanReminderOpen(true);
      return;
    }

    // Auto-enable loan for mandatory cases (crypto mandatory loans)
    if (autoEnableLoan && !IsOnBoosterLoan) {
      setOnBoosterLoan(true);
      return
    }

    // Proceed with order
    if (assetType === 'crypto') {
      await cryptoOrder(orderType);
    } else {
      await stockBuy(orderType);
    }
  };

  const handleBoosterLoanReminderYes = () => {
    if (dontRemind30Days) {
      saveDontRemindPreference();
    }
    setBoosterLoanReminderOpen(false);
    setDontRemind30Days(false);
    setOnBoosterLoan(true);
    // The loan will be activated and user can proceed
  };

  const handleBoosterLoanReminderNo = async () => {
    if (dontRemind30Days) {
      saveDontRemindPreference();
    }
    setBoosterLoanReminderOpen(false);
    setDontRemind30Days(false);
    // Proceed with order without booster loan
    const orderType = pendingOrderType as "Buy" | "Sell";
    if (orderType) {
      if (assetType === 'crypto') {
        await cryptoOrder(orderType);
      } else {
        await stockBuy(orderType);
      }
    }
    setPendingOrderType(null);
  };

  const handleBoosterLoanReminderLearnMore = () => {
    if (dontRemind30Days) {
      saveDontRemindPreference();
    }
    setBoosterLoanReminderOpen(false);
    setDontRemind30Days(false);
    navigate('/boosterlending');
  };

  useEffect(() => {
    if (user?.achHold) {
      const holdDate = new Date(user.achHold).getTime();
      const now = new Date().getTime();
      setIsAchHoldActive(holdDate > now);
    } else {
      setIsAchHoldActive(false);
    }
  }, [user?.achHold]);

  useEffect(() => {
    setOnBoosterLoan(false)
    // if (IsOnBoosterLoan) {
    //   setRecalculate(true)
    //   fetchLoanEligibility()
    //   setLoanAmount(estimatedAmount)
    // }
  }, [estimatedAmount])

  useEffect(() => {
    if (IsOnBoosterLoan && !isAchHoldActive) {
      // fetchLoanAmount(null, true)
      fetchLoanEligibility(true)
      fetchAllPaymentMethods()
    }
  }, [IsOnBoosterLoan])

  useEffect(() => {
    fetchTradingBalance();
    if (!isAchHoldActive) {
      fetchBoosterLoanData();
    }
  }, [stockDetail])

  // useEffect(() => {
  //   if (stockDetail?.symbol && user?.tradingblock_application_id && assetType !== "crypto") {
  //     // fetchAvailbleQty()
  //   }
  // }, [stockDetail])

  useEffect(() => {
    setOnBoosterLoan(false)
    setEstimatedAmount(0)
    setStockQty(0)
  }, [isBuyActive])

  // Calculate remaining loan quantity for current symbol
  useEffect(() => {
    if (cryptoLoanData?.stockData.length > 0 && stockDetail?.symbol) {
      const matchingStock = cryptoLoanData.stockData.find(
        (stock: any) => stock.stockSymbol?.toUpperCase() === stockDetail.symbol?.toUpperCase()
      );
      setRemainingLoanQuantity(matchingStock?.remainingQuantity || 0);
      setToolTipAmount(matchingStock?.loanAmount || 0);
    } else {
      setRemainingLoanQuantity(0);
      setToolTipAmount(0);
    }
  }, [cryptoLoanData, stockDetail?.symbol, assetType])

  const onChangeRatio = (newSelection, options?: { fromRatio?: boolean }) => {

    if (isSellActive) {
      setSelectLimit("Market")

      const qtyAvailable = Number(availabelQty) || 0; // Default to 0 if undefined
      let estimatedAmt = 0;
      let qty = 0;
      switch (newSelection) {
        case "1/4":
          qty = qtyAvailable * 0.25; // 25% of qtyAvailable
          break;
        case "1/2":
          qty = qtyAvailable * 0.5; // 50% of qtyAvailable
          break;
        case "3/4":
          qty = qtyAvailable * 0.75; // 75% of qtyAvailable
          break;
        case "Full":
          qty = qtyAvailable; // Full qtyAvailable
          break;
        default:
          console.error("Invalid selection");
          break;
      }

      // Calculate Quantity
      const lastPrice = tickerData?.lastPrice || 1; // Avoid division by 0
      // qty = estimatedAmt / lastPrice;
      estimatedAmt = qty * lastPrice; // Calculate Estimated Budget

      // Adjust based on isFractional
      // if (IsOnBoosterLoan && !tickerDataAll?.isFractional) {

      //   qty = Math.trunc(estimatedAmt / lastPrice)  // Round to nearest whole number
      //   estimatedAmt = qty * lastPrice; // Recalculate Estimated Budget

      // }

      // Update state
      setEstimatedAmount(estimatedAmt);
      setStockQty(qty);

    } else {
      setSelectLimit("Market")
      const balance = Number(tradingInfo?.BuyingPower?.AvailableFunds) || 0; // Default to 0 if undefined
      let estimatedAmt = 0;
      let qty = 0;
      switch (newSelection) {
        case "1/4":
          estimatedAmt = balance * 0.25; // 25% of balance
          break;
        case "1/2":
          estimatedAmt = balance * 0.5; // 50% of balance
          break;
        case "3/4":
          estimatedAmt = balance * 0.75; // 75% of balance
          break;
        case "Full":
          estimatedAmt = balance; // Full balance
          break;
        default:
          console.error("Invalid selection");
          break;
      }

      // Calculate Quantity
      const lastPrice = tickerData?.lastPrice || 1; // Avoid division by 0
      qty = estimatedAmt / lastPrice;

      // Adjust based on isFractional; skip during ratio-triggered change because loan is being disabled
      if (IsOnBoosterLoan && !options?.fromRatio && !tickerDataAll?.isFractional) {

        qty = Math.trunc(estimatedAmt / lastPrice)  // Round to nearest whole number
        estimatedAmt = qty * lastPrice; // Recalculate Estimated Budget

      }

      setEstimatedAmount(estimatedAmt);
      setStockQty(qty);

      // After computing based on ratio, ensure booster loan is turned off so UI reflects new state
      if (IsOnBoosterLoan) {
        setOnBoosterLoan(false);
      }
    }
  };

  const handleQtyChange = (newQty) => {
    const price = selectLimit === "Limit" ? limitPrice : tickerData?.lastPrice || 1; // Use limitPrice if "Limit", otherwise fallback to lastPrice

    setSelectedRatio(""); // Clear the ratio filter

    let qty = newQty;
    let estimatedAmt = qty * price;

    // Adjust based on isFractional
    if (IsOnBoosterLoan && !tickerDataAll?.isFractional) {
      qty = Math.round(qty); // Round to nearest whole number
      estimatedAmt = qty * price; // Recalculate Estimated Budget
    }

    setStockQty(qty); // Update Qty
    setEstimatedAmount(estimatedAmt); // Update Estimated Budget
  };

  const handleCancelOrder = async () => {
    try {
      dispatch(startLoading());
      setLoading(true);
      const requestBody = { userId: user?._id, orderId: cryptoOrderId };
      const url = UrlConstant.Crypto.CancelOrder;
      const response = await Axios.post(url, requestBody);
      const success = response?.data?.success ?? false;
      const message = response?.data?.message ?? "Failed to cancel the order.";

      setheading(success ? "Success" : "Error");
      setSuccess(success);
      setShowPopup(true);
      setmsg(message);

      if (success) {
        fetchTradingBalance();
      }
    } catch (error) {
      setheading("Error");
      setSuccess(false);
      setShowPopup(true);
      setmsg("An error occurred while canceling the order.");
    } finally {
      setLoading(false);
      setOtpModalOpen(false);
    }
  };


  const handleEstimatedAmountChange = (
    newEstimatedAmount: string | number
  ) => {
    const price =
      selectLimit === "Limit"
        ? limitPrice
        : tickerData?.lastPrice || 1;

    setSelectedRatio("");

    const inputAmount = newEstimatedAmount;

    // BUY FLOW
    if (isBuyActive) {
      const availableBalance =
        tradingInfo?.BuyingPower?.AvailableFunds || 0;

      const isCapped =
        inputAmount > availableBalance;

      if (isCapped) {
        handleselect("Full");
        return;
      }
    }

    if (isSellActive) {
      const estimatedQty = Number(inputAmount) / price;

      const availableQty =
        Number(availabelQty) || 0;

      const isCapped =
        estimatedQty > availableQty;

      if (isCapped) {
        handleselect("Full");
        return;
      }
    }
    const qty = Number(inputAmount) / price;
    setEstimatedAmount(inputAmount);
    setStockQty(qty);
  };

  useEffect(() => {
    if (selectLimit == "Limit") {
      let estimatedAmt = stockQty * limitPrice;
      setEstimatedAmount(estimatedAmt); // Update Estimated Budget
    }

  }, [limitPrice, selectLimit])
  const closePopup = () => {
    setShowPopup(false); // Function to close the popup
  };

  return (
    <div className="buy">
      <Card className="card" sx={{ width: "100%", height: '100%', paddingBottom: "0px" }}>
        <CardContent sx={{ padding: "0px !important" }}>
          {isLoaninfo && <Typography className="p-3 text-white" display='flex' alignItems='center' fontSize='20px' fontWeight={600} sx={{ cursor: 'pointer' }} onClick={handleinfo}><IconButton sx={{ marginRight: '10px' }}><KeyboardArrowLeftOutlined sx={{ height: '30px', width: '30px' }} /></IconButton>Loan Information</Typography>}
          {
            ispayment ?
              <>
                <Typography className="p-3 text-white" fontSize='20px'><IconButton onClick={handlepayment}><KeyboardArrowLeftOutlined sx={{ height: '30px', width: '30px' }} /></IconButton>Re-payment Method</Typography>
              </>
              : <>
                <Box
                  // mb={3}
                  padding='30px'
                  // pb={0}
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' }, // Responsive layout
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    gap: '15px',
                  }}
                >
                  {/* Stock Details */}
                  <Box className="text-white" display="flex" alignItems="center" gap="15px">
                    <Avatar
                      alt={stockDetail?.displayName}
                      src={icon}
                      sx={{
                        width: 36,
                        height: 36,
                        backgroundColor: "white",
                        objectFit: "fill",
                      }}
                      className="icon"
                    />
                    <Box>
                      <Box display="flex">
                        <Typography
                          variant="h5"
                          mb={0.5}
                          sx={{
                            fontSize: { xs: '14px', sm: '16px' },
                            fontWeight: 600,
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 1, // Limits text to 2 lines
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'normal',
                          }}
                        >
                          {stockDetail?.displayName}
                        </Typography>
                        {(boosterLoanDetails?.isEligible) ? (
                          <Box sx={{ ml: 1 }}>
                            <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0 16L3.38446 11.0694H0.509992L3.70898 6.42901H0.18548L4.96068 0H9L5.56346 4.01205L8.87498 3.91541L4.76159 9.136H8.02063L0 16Z" fill="url(#paint0_linear_483_3687)" />
                              <defs>
                                <linearGradient id="paint0_linear_483_3687" x1="4.5" y1="8.20062e-08" x2="-0.358359" y2="15.8904" gradientUnits="userSpaceOnUse">
                                  <stop stop-color="#EEA415" />
                                  <stop offset="1" stop-color="#FFD25E" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </Box>
                        ) : null}

                      </Box>
                      <Typography
                        variant="body2"
                        className="text-secondary"
                        sx={{
                          fontSize: '10px',
                          color: '#9E9E9E',
                        }}
                      >
                        {stockDetail?.stockExchangeCode
                          ? `${stockDetail.stockExchangeCode}:${stockDetail.symbol}`
                          : stockDetail?.symbol}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Price Details */}
                  <Box>
                    <Box
                      display="flex"
                      justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}
                      flexWrap="wrap"
                    // gap="10px"
                    >
                      <Typography
                        // variant="h6"
                        className="text-white"
                        sx={{
                          fontSize: { xs: '16px' },
                          // fontWeight: 700,
                          textAlign: { xs: 'left', sm: 'right' },
                        }}
                      >
                        {formatter.display(tickerData?.lastPrice, { assetType: assetType === 'crypto' ? AssetType.CRYPTO : AssetType.STOCK })} &nbsp;
                        <span style={{ color: tickerData.diffAmount > 0 ? "#4edf6d" : "#ff2a2a", }}>
                          {formatter.display(tickerData.diffAmount, {
                            assetType:
                              assetType === 'crypto'
                                ? AssetType.CRYPTO
                                : AssetType.STOCK,
                            showSign: true,
                          })}
                          ({formatPercentage(tickerData.percentage, { showSign: true })})
                        </span>
                      </Typography>
                      {/* Only show Wallet Balance for stocks */}
                      <Typography
                        // variant="body2"
                        sx={{
                          fontSize: '12px',
                          // color: tickerData.diffAmount > 0 ? "#4edf6d" : "#ff2a2a",
                          color: '#4A7AF2',
                          fontWeight: 500,
                        }}
                      >
                        Wallet Balance: {formatter.balance(tradingInfo?.BuyingPower?.AvailableFunds).display}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                {/* <Typography
                  variant="body2"
                  sx={{
                    color: '#4A7AF2',
                    fontSize: '12px',
                    textAlign: { xs: 'left', sm: 'right' },
                  }}
                >
                  Wallet Balance: $ {tradingInfo?.BuyingPower?.AvailableFunds}
                </Typography> */}

                {/* Separator */}
                {/* <hr style={{ borderColor: '#FFFFFF70', margin: '0px' }} /> */}
                {/* <Box display="flex" justifyContent="space-between" mt="10px">
                  <Typography
                    variant="body2"
                    className="text-secondary"
                    sx={{
                      fontSize: '12px',
                      color: '#9E9E9E',
                    }}
                  >
                    ASk Price: {tickerDataAll?.Ask}
                  </Typography>
                  <Typography
                    variant="body2"
                    className="text-secondary"
                    sx={{
                      fontSize: '12px',
                      color: '#9E9E9E',
                    }}
                  >
                    Bid Price: {tickerDataAll?.Bid}
                  </Typography>
                </Box> */}
              </>
          }
          {isLoaninfo ? <Loaninfo stockDetail={stockDetail} loanAmountData={loanAmountData} stockQty={stockQty} decimals={decimals} /> : ispayment ? <Repayment paymentMethods={paymentMethods} setSelectedPaymentMethod={handleLoanPaymentMethodChange} handlepayment={handlepayment} fetchPaymentMethods={fetchAllPaymentMethods} /> :
            <>
              {/* Current Holding Amount */}
              {/* {(availabelQty > 0 || remainingLoanQuantity > 0) && ( */}
              <Box
                sx={{
                  bgcolor: 'rgba(78, 223, 109, 0.15)',
                  borderRadius: '12px',
                  p: 2,
                  mx: 2,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Typography sx={{ color: '#4EDF6D', fontSize: '16px', fontWeight: 600 }}>
                  Current Holdings
                </Typography>
                <Box display="flex" alignItems="center" gap="6px">
                  <Typography sx={{ color: '#4EDF6D', fontSize: '18px', fontWeight: 700 }}>
                    {formatter.balance(
                      ((availabelQty || 0) + (remainingLoanQuantity || 0)) * (tickerData?.lastPrice || 0),
                    ).display}
                  </Typography>
                  {remainingLoanQuantity > 0 && (
                    <Tooltip
                      placement="top"
                      arrow
                      title={
                        <Box sx={{ width: '100%' }}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontWeight: 400,
                              fontSize: '12px',
                              lineHeight: '16px',
                              color: 'rgba(255, 255, 255, 0.5)',
                            }}
                          >
                            <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0 16L3.38446 11.0694H0.509992L3.70898 6.42901H0.18548L4.96068 0H9L5.56346 4.01205L8.87498 3.91541L4.76159 9.136H8.02063L0 16Z" fill="url(#paint0_linear_loan)" />
                              <defs>
                                <linearGradient id="paint0_linear_loan" x1="4.5" y1="0" x2="-0.358359" y2="15.8904" gradientUnits="userSpaceOnUse">
                                  <stop stopColor="#EEA415" />
                                  <stop offset="1" stopColor="#FFD25E" />
                                </linearGradient>
                              </defs>
                            </svg>
                            Booster Loan Pending Amount
                          </Box>
                          <Box
                            sx={{
                              marginTop: '8px',
                              fontWeight: 800,
                              fontSize: '20px',
                              lineHeight: '27px',
                              color: '#FFFFFF',
                              textAlign: 'center',
                            }}
                          >
                            {formatter.display(toolTipAmount, { assetType: AssetType.USD })}
                          </Box>
                          <Box
                            sx={{
                              margin: '8px 0 6px',
                              borderTop: '1px solid rgba(255, 255, 255, 0.2)',
                              width: '100%',
                            }}
                          />
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              paddingBottom: '10px',
                            }}
                          >
                            <span
                              style={{
                                fontWeight: 400,
                                fontSize: '12px',
                                lineHeight: '14px',
                                textDecoration: 'underline',
                                color: '#4A7AF2',
                                cursor: 'pointer',
                                textAlign: 'center',
                              }}
                              onClick={() => navigate('/boosterLoan', { state: { category: 'Activeloans' } })}
                            >
                              View details
                            </span>
                          </Box>
                        </Box>
                      }
                    >
                      <svg
                        width="10"
                        height="18"
                        viewBox="0 0 10 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: 'pointer' }}
                      >
                        <path
                          d="M0 16L3.38446 11.0694H0.509992L3.70898 6.42901H0.18548L4.96068 0H9L5.56346 4.01205L8.87498 3.91541L4.76159 9.136H8.02063L0 16Z"
                          fill="url(#paint0_linear_buysell)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_buysell"
                            x1="4.5"
                            y1="0"
                            x2="-0.358359"
                            y2="15.8904"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#EEA415" />
                            <stop offset="1" stopColor="#FFD25E" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </Tooltip>
                  )}
                </Box>
              </Box>
              {/* )} */}

              <Box
                borderBottom="1px"
                borderColor="#FFFFFF"
                display="flex"
                width="100%"
                mt={1}
                justifyContent="space-between"
              >
                <Button
                  ref={buyButtonRef}
                  onClick={handleBuyClick}
                  sx={{
                    border: "none",
                    width: "50%",
                    bgcolor: "transparent",
                    display: "flex",
                    justifyContent: "center",
                    borderBottom: isBuyActive ? "3px solid #4edf6d" : "none",
                  }}
                >
                  <Typography
                    textAlign="center"
                    variant="body1"
                    sx={{ color: isBuyActive ? "#4EDF6D" : "white" }}
                  >
                    Buy
                  </Typography>
                </Button>
                <Button
                  ref={sellButtonRef}
                  onClick={handleSellClick}
                  sx={{
                    border: "none",
                    width: "50%",
                    borderBottom: isSellActive ? "3px solid #FF2A2A" : "none",
                    bgcolor: "transparent",
                    display: "flex",
                    justifyContent: "center",
                    "&.Mui-disabled": {
                      cursor: "not-allowed",
                      pointerEvents: "auto",
                    },
                  }}
                  // disabled={isC2CRestricted || (!availabelQty && !remainingLoanQuantity)}
                  disabled={!availabelQty && !remainingLoanQuantity}
                >
                  <Typography
                    textAlign="center"
                    variant="body1"
                    sx={{
                      color: isSellActive ? "#FF2A2A" : (!availabelQty && !remainingLoanQuantity) ? "gray" : "white",

                    }}
                  >
                    {" "}
                    Sell{" "}
                  </Typography>
                </Button>
              </Box>
              <hr style={{ borderColor: "#FFFFFF70", margin: "0px" }}></hr>
              <>
                <Box p='20px 30px 0px 30px' mb='10px'>
                  {true &&
                    <ToggleButtonGroup
                      // className="border-white"
                      // color="primary"
                      // fullWidth
                      value={selection}
                      exclusive
                      onChange={(event, newFilter) => {
                        if (newFilter !== null) {
                          handleselect(newFilter);
                        }
                      }}
                      aria-label="Platform"
                      sx={{
                        fontSize: '14px',
                        '.MuiToggleButton-root:hover': { color: isSellActive ? "#FF2A2A !important" : '', bgcolor: isSellActive ? "#FF2A2A20 !important" : '' },
                        '.MuiToggleButton-root.Mui-selected': { color: isSellActive ? "#FF2A2A !important" : '', bgcolor: isSellActive ? "#FF2A2A20 !important" : '' }
                      }}
                    >
                      <ToggleButton value="1/4" sx={{ fontSize: '14px', lineHeight: '0' }}>1/4</ToggleButton>
                      <ToggleButton value="1/2">1/2</ToggleButton>
                      <ToggleButton value="3/4">3/4</ToggleButton>
                      <ToggleButton value="Full">Full</ToggleButton>
                    </ToggleButtonGroup>
                  }
                </Box>

                {isSellActive &&
                  <Box className='px-4 mb-3' display='flex' alignItems='center' justifyContent='space-between'>
                    <Typography className="text-secondary">Available Qty.</Typography>
                    <Typography className="text-white">{availabelQty}</Typography>
                    {/* <PriceAdjuster value={limitPrice} setValue={setLimitPrice} /> */}
                  </Box>
                }
                {
                  selectLimit === 'Limit' && <Box className='px-4 mb-3' display='flex' alignItems='center' justifyContent='space-between'>
                    <Typography className="text-secondary">Limit Price</Typography>
                    <PriceAdjuster value={limitPrice} setValue={setLimitPrice} />

                  </Box>
                }
                <Box className='px-4' mb='10px' display='flex' alignItems='center' justifyContent='space-between'>
                  <Typography className="text-secondary">
                    Qty. {assetType !== 'crypto' && !tickerDataAll?.isFractional ? "(Whole)" : null}
                  </Typography>
                  <TextField className="w-25" id="outlined-basic"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "10px !important",

                      },
                      '& .MuiInputBase-input.Mui-disabled': {
                        cursor: "not-allowed",
                        pointerEvents: "auto",
                        color: "#fff",
                        WebkitTextFillColor: "#fff",
                        opacity: 0.6,
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "10px",
                        height: '36px',
                        boxSizing: 'border-box',
                        textAlign: 'end !important',
                        color: `${!isBuyActive && Number(stockQty) > availabelQty ? "#FF2A2A !important" : "#4edf6d !important"}`


                      }
                    }} variant="outlined"
                    value={formatter.quantity(stockQty, assetType === 'crypto' ? AssetType.CRYPTO : AssetType.STOCK).display}
                    disabled={assetType === 'crypto'}
                    onChange={(e) => handleQtyChange(e.target.value)}
                  />
                </Box>
                <Box className='px-4' display='flex' alignItems='center' justifyContent='space-between'>
                  {assetType === 'crypto' ? (
                    <>
                      <Typography className="text-secondary">Amount (Approx)</Typography>
                      <TextField
                        className="w-25 text-success"
                        id="filled-basic"
                        sx={{
                          "& .MuiFilledInput-root": {
                            borderRadius: "10px !important",
                            backgroundColor: 'rgba(20, 20, 20, 0.5)',
                            '&:before': { border: 'none !important' }
                          },
                          "& .MuiFilledInput-input": {
                            padding: "10px",
                            height: '36px',
                            boxSizing: 'border-box',
                            textAlign: 'end !important',
                            color: "#4edf6d !important"
                          },
                        }}
                        variant="filled"
                        value={estimatedAmount}
                        onChange={e => {
                          const val = e.target.value;
                          // allow empty or numbers with one optional decimal point
                          if (val === '' || /^[0-9]*\.?[0-9]*$/.test(val)) {
                            handleEstimatedAmountChange(val);
                          }
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment>
                              <Typography sx={{ color: '#4edf6d' }}>{currencyInfo?.symbol}</Typography>
                            </InputAdornment>
                          ),
                          inputProps: {
                            inputMode: 'decimal',
                            pattern: '^[0-9]*\\.?[0-9]*$',
                            maxLength: 18,
                            onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
                              const allowed = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'];
                              if (allowed.includes(e.key)) return;
                              if (e.key === '.' && (e.currentTarget.value ?? '').includes('.')) {
                                e.preventDefault(); // block second dot
                                return;
                              }
                              if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                            }
                          }
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <Box display={"flex"} alignItems={"center"}>
                        <Typography className="text-secondary">Estimated</Typography>
                        <FormControl variant="standard" sx={{ m: 0, minWidth: 120 }}>
                          <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            value={selectLimit}
                            className="text-white "
                            onChange={handleChange}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  bgcolor: "rgba(0,0,0,0.4)!important", // set the dropdown background color here
                                  "& .MuiMenuItem-root": {
                                    color: "white !important", // set the text color of menu items
                                    margin: '0px'
                                  },
                                },
                              },
                            }}
                            sx={{
                              width: 'fit-content',
                              m: '0px',
                              ".MuiFormControl-root": {
                                margin: '0px'
                              },
                              color: "white !important", // Set the color for the select text
                              "&:before": {
                                borderBottom: "2px dashed white", // Initial underline color
                              },
                              "&:before:hover": {
                                borderBottom: "2px dashed white", // Initial underline color
                              },
                              "&:after": {
                                borderBottom: "2px dashed white", // Underline color when focused
                              }
                            }}
                          >
                            <MenuItem value="Market" className="text-white bg-color">Market</MenuItem>
                            <MenuItem value="Limit" className="text-white bg-color">Limit</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                      <TextField
                        className="w-25 text-success" id="filled-basic"
                        sx={{
                          "& .MuiFilledInput-root": {
                            borderRadius: "10px !important",
                            backgroundColor: 'rgba(20, 20, 20, 0.5)',
                            '&:before': {
                              border: 'none !important'
                            }
                          },
                          "& .MuiFilledInput-input": {
                            padding: "10px",
                            height: '36px',
                            boxSizing: 'border-box',
                            textAlign: 'end !important',
                            color: `${estimatedAmount <= tradingInfo?.BuyingPower?.AvailableFunds ? "#4edf6d !important" : isBuyActive ? "#FF2A2A !important" : "#4edf6d !important"}`
                          },
                        }}
                        variant="filled"
                        value={`${estimatedAmount}`}
                        // disabled={!tickerDataAll?.isFractional}
                        onChange={(e) => handleEstimatedAmountChange(e.target.value)}
                      />
                    </>
                  )}
                </Box>


                {/* here shows the message if only availabelQty is 0 and remainingLoanQuantity grater then 0  */}
                {isSellActive && remainingLoanQuantity > 0 && assetType === 'crypto' ? (
                  <Box
                    sx={{
                      background: `url(${buySellBg})`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      overflow: 'hidden',
                      p: 2,
                      m: 2,
                      borderRadius: '16px',

                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                        alignItems: 'center',
                      }}
                    >
                      {/* Animated Thunder Icon - Same as Activate Loan */}
                      <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Box
                          sx={{
                            position: 'absolute',
                            width: 50,
                            height: 50,
                            borderRadius: '50%',
                            background: 'radial-gradient(closest-side, rgba(255,193,7,0.4), rgba(255,193,7,0.15), transparent)',
                            filter: 'blur(6px)',
                            animation: `${pulseGlow} 2.6s ease-in-out infinite`,
                          }}
                        />
                        <Box
                          sx={{
                            position: 'absolute',
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            border: '1px solid rgba(255,193,7,0.6)',
                            animation: `${flashRing} 2s ease-out infinite`,
                          }}
                        />
                        <Box
                          component="img"
                          src={thunderIcon}
                          alt="thunder"
                          sx={{
                            height: 40,
                            display: 'block',
                            animation: `${floatY} 3s ease-in-out infinite, ${bounceJump} 5s ease-in-out infinite`,
                            transformOrigin: 'center',
                            position: 'relative',
                            zIndex: 1
                          }}
                        />
                      </Box>

                      {/* Message Text */}
                      <Typography
                        variant="h6"
                        sx={{
                          color: '#fff',
                          fontSize: { xs: '14px', sm: '15px' },
                          fontWeight: 600,
                          textAlign: 'center',
                          lineHeight: 1.3,
                          mt: 0.5,
                        }}
                      >
                        You’re currently holding{' '}
                        <span style={{ color: '#EEA415', fontWeight: 700 }}>
                          {formatter.quantity(remainingLoanQuantity).display}
                        </span>{' '}
                        <span style={{ color: '#EEA415', fontWeight: 700 }}>
                          {stockDetail?.symbol}
                        </span>{' '}
                        backed by Booster Loans
                      </Typography>

                      {/* View Loans Link */}
                      <Button
                        onClick={() => navigate('/boosterLoan', { state: { category: 'Activeloans' } })}
                        sx={{
                          color: '#FF6B4A',
                          fontWeight: 600,
                          fontSize: '14px',
                          textTransform: 'none',
                          textDecoration: 'underline',
                          background: 'none',
                          border: 'none',
                          padding: 0,
                          minWidth: 'auto',
                          mt: 0.5,
                          '&:hover': {
                            background: 'none',
                            color: '#FF8A6A',
                            textDecoration: 'underline',
                          },
                        }}
                      >
                        View Loans
                      </Button>
                    </Box>
                  </Box>
                ) : null}
                {/* <IconButton onClick={handlepayment} sx={{ width: "100%" }}>
                  <Box
                    width="100%"
                    display="flex"
                    mt={2}
                    alignItems="center"
                    p={1}
                    sx={{ background: "linear-gradient(45deg, #4b2c20, #5e4028)" }}
                  >
                    <CreditCardIcon
                      fontSize="small"
                      sx={{ color: "#ffbf00", mr: 1 }}
                    />
                    <Typography variant="body2" className="text-white">
                      Payment Method
                    </Typography>
                    <Box flexGrow={1} />
                    <AccountBalanceIcon sx={{ color: "white" }} />
                    <Typography variant="body2" sx={{ ml: 1 }} className="text-white">
                      {selectedPaymentMethod?.payment ? selectedPaymentMethod?.payment?.creditCard?.cardNumber : selectedPaymentMethod?.customerPaymentProfileId} &gt;
                    </Typography>
                  </Box>
                </IconButton> */}
                {/* Booster loan disabled for now */}
                {!isSellActive && (user?.boosterLoanOptIn === true || !!user?.boosterloan_id) ?
                  <>
                    {boosterLoanDetails?.isEligible && !isAchHoldActive ? (
                      <>
                        <hr style={{ borderColor: "#FFFFFF70", margin: "20px 0px 0px 0px" }} />
                        <Box
                          sx={{
                            background: `url(${buySellBg})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            // borderRadius: 2,
                            // margin: '0px 30px',
                            overflow: 'hidden',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          <Box padding='0px 10px' sx={{ pt: '20px', pb: '10px', display: 'grid', gridTemplateColumns: 'auto 1fr auto', alignItems: 'center', columnGap: '12px' }}>
                            <Box sx={{ position: 'relative', width: 40, height: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <Box
                                sx={{
                                  position: 'absolute',
                                  width: 42,
                                  height: 42,
                                  borderRadius: '50%',
                                  background: 'radial-gradient(closest-side, rgba(255,193,7,0.35), rgba(255,193,7,0.1), transparent)',
                                  filter: 'blur(4px)',
                                  animation: `${pulseGlow} 2.6s ease-in-out infinite`,
                                }}
                              />
                              <Box
                                sx={{
                                  position: 'absolute',
                                  width: 40,
                                  height: 40,
                                  borderRadius: '50%',
                                  border: '1px solid rgba(255,193,7,0.6)',
                                  animation: `${flashRing} 2s ease-out infinite`,
                                }}
                              />
                              <Box
                                component="img"
                                src={thunderIcon}
                                alt="thunder"
                                sx={{ height: 50, display: 'block', animation: `${floatY} 3s ease-in-out infinite, ${bounceJump} 5s ease-in-out infinite`, transformOrigin: 'center' }}
                              />
                            </Box>

                            <Box>
                              <Box display={'flex'} alignItems={'flex-start'} justifyContent={'space-between'}>
                                <Box display='flex' alignItems='center' gap='8px'>
                                  <Typography sx={{ fontSize: { xs: '16px', sm: '16px' }, fontWeight: 700, color: '#fff' }}>
                                    Activate Booster Loan {boosterLoanDetails?.lvrPercentage ? ` - Up to ${boosterLoanDetails.lvrPercentage}%` : ""}
                                  </Typography>
                                </Box>
                                <Switch
                                  checked={IsOnBoosterLoan}
                                  onChange={handleswitch}
                                  sx={{ marginTop: '-8px' }}
                                />
                              </Box>
                              <Typography sx={{ color: 'rgba(255,255,255,0.85)', fontSize: 10 }}>
                                Invest Now, Pay Later with our Booster Loans! Minimum $50 Loan Amount.
                              </Typography>
                            </Box>


                          </Box>
                          {IsOnBoosterLoan && loanAmountData && loanElogibilityData && (
                            <Box className='px-4' sx={{ pb: '20px' }}>
                              <LoanDetails
                                tickerData={tickerData}
                                decimals={decimals}
                                stockDetail={stockDetail}
                                setOtpModalOpen={setOtpModalOpen}
                                boosterLoading={boosterLoading}
                                isGlobalLoading={loading}
                                loanAmountData={loanAmountData}
                                loanElogibilityData={loanElogibilityData}
                                setLoanEligibilityData={setLoanEligibilityData}
                                recalculate={recalculate}
                                onRecalculate={onRecalculate}
                                setOnBoosterLoan={setOnBoosterLoan}
                                setRecalculate={setRecalculate}
                                setLoanAmount={setLoanAmount}
                                stockQty={stockQty}
                                estimatedAmount={estimatedAmount}
                                setloaninfo={handleinfo}
                                setpayment={handlepayment}
                                onBuyNow={onBuyNow}
                                acceptCondition={acceptCondition}
                                setacceptCondition={setacceptCondition}
                                selectedPaymentMethod={selectedPaymentMethod}
                              />
                            </Box>)
                          }
                        </Box>
                      </>) : stockDetail?.isLoanAvailable && !boosterLoanDetails?.isEligible ? (
                        <Box
                          sx={{
                            mt: '20px',
                            background: `url(${buySellBg})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            overflow: 'hidden',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          <Box padding='0px 10px' sx={{ pt: '20px', pb: '20px', display: 'grid', gridTemplateColumns: 'auto 1fr', alignItems: 'center', columnGap: '12px' }}>
                            <Box sx={{ position: 'relative', width: 40, height: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <Box
                                sx={{
                                  position: 'absolute',
                                  width: 42,
                                  height: 42,
                                  borderRadius: '50%',
                                  background: 'radial-gradient(closest-side, rgba(255,193,7,0.35), rgba(255,193,7,0.1), transparent)',
                                  filter: 'blur(4px)',
                                  animation: `${pulseGlow} 2.6s ease-in-out infinite`,
                                }}
                              />
                              <Box
                                sx={{
                                  position: 'absolute',
                                  width: 40,
                                  height: 40,
                                  borderRadius: '50%',
                                  border: '1px solid rgba(255,193,7,0.6)',
                                  animation: `${flashRing} 2s ease-out infinite`,
                                }}
                              />
                              <Box
                                component="img"
                                src={thunderIcon}
                                alt="thunder"
                                sx={{ height: 50, display: 'block', animation: `${floatY} 3s ease-in-out infinite, ${bounceJump} 5s ease-in-out infinite`, transformOrigin: 'center' }}
                              />
                            </Box>

                            <Box>
                              <Typography sx={{ fontSize: { xs: '16px', sm: '16px' }, fontWeight: 700, color: '#fff', mb: 0.5 }}>
                                Booster Loan Unavailable
                              </Typography>
                              <Typography sx={{ color: 'rgba(255,255,255,0.85)', fontSize: 12 }}>
                                Unfortunately, Booster Loans are not available for {stockDetail?.displayName} at the moment. Please try again later.
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      ) : null
                    }

                    {IsOnBoosterLoan && !isAchHoldActive && loanAmountData && (
                      <>
                        <hr style={{ borderColor: "#FFFFFF70", margin: "0px 0px 0px 0px" }} />
                        <Box px={4} pt={2} pb={2}>
                          <Box display="flex" justifyContent="space-between">
                            <Typography variant="body1" className="text-secondary">
                              Total Qty.
                            </Typography>
                            <Typography variant="body1" className="text-secondary">
                              {(() => {
                                const currentPrice = tickerData?.lastPrice ?? 0;
                                const usrQty = currentPrice > 0 ? Number(estimatedAmount) / currentPrice : 0;
                                const loanQty = currentPrice > 0 ? Number(loanAmountData?.offer?.offerPrice) / currentPrice : 0;
                                const totalQty = usrQty + loanQty;
                                return formatter.quantity(totalQty).display;
                              })()}
                            </Typography>
                          </Box>
                          <Box display="flex" justifyContent="space-between" mt={1}>
                            <Typography variant="body1" className="text-secondary">
                              Total Amount
                            </Typography>
                            <Typography variant="body1" className="text-secondary">
                              {formatter.amount(Number(estimatedAmount) + Number(loanAmountData?.offer?.offerPrice || 0)).display}
                            </Typography>
                          </Box>

                          <hr style={{ borderColor: "#FFFFFF70", margin: "20px 0px 0px 0px" }} />
                          <Box my={2} display="flex" justifyContent="space-between">
                            <Button
                              variant="outlined"
                              onClick={handleinfo}
                              sx={{
                                color: "#4edf6d",
                                borderColor: "#4edf6d",
                                width: "48%",
                                borderRadius: "20px",
                                py: "10px",
                              }}
                            >
                              View Details
                            </Button>
                            <Button
                              onClick={() => { onBuyNow("Buy") }}
                              // disabled={isC2CRestricted}
                              variant="contained"
                              className="btn-success"
                              sx={{
                                width: "48%",
                                borderRadius: "20px",
                                fontWeight: 600,
                                color: "black",
                              }}
                            >
                              Buy Now
                            </Button>
                          </Box>
                        </Box>
                      </>
                    )}
                  </>
                  :
                  !isSellActive && (
                    <>
                      <hr style={{ borderColor: "#FFFFFF70", margin: "20px 0px 0px 0px" }} />
                      <Box
                        sx={{
                          background: `url(${buySellBg})`,
                          backgroundSize: 'cover',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                          overflow: 'hidden',
                          p: 2,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center',
                          gap: 2,
                          cursor: 'pointer',
                          transition: 'transform 0.2s ease',
                          '&:hover': {
                            transform: 'scale(1.02)',
                          }
                        }}
                        onClick={() => navigate('/boosterlending')}
                      >
                        <Box sx={{ position: 'relative', width: 60, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Box
                            sx={{
                              position: 'absolute',
                              width: 60,
                              height: 60,
                              borderRadius: '50%',
                              background: 'radial-gradient(closest-side, rgba(255,193,7,0.4), rgba(255,193,7,0.15), transparent)',
                              filter: 'blur(6px)',
                              animation: `${pulseGlow} 2.6s ease-in-out infinite`,
                            }}
                          />
                          <Box
                            component="img"
                            src={thunderIcon}
                            alt="thunder"
                            sx={{ height: 50, display: 'block', animation: `${floatY} 3s ease-in-out infinite, ${bounceJump} 5s ease-in-out infinite`, transformOrigin: 'center', position: 'relative', zIndex: 1 }}
                          />
                        </Box>
                        <Typography sx={{ fontSize: { xs: '18px', sm: '22px' }, fontWeight: 700, color: '#fff' }}>
                          Activate Booster Loan {boosterLoanDetails?.lvrPercentage ? ` - Up to ${boosterLoanDetails.lvrPercentage}%` : ""}
                        </Typography>
                        <Typography sx={{ color: 'rgba(255,255,255,0.85)', fontSize: 14, maxWidth: '400px' }}>
                          Invest Now, Pay Later with our Booster Loans! Register now to unlock instant trading power.
                        </Typography>
                        <Button
                          variant="contained"
                          sx={{
                            mt: 1,
                            borderRadius: '20px',
                            px: 4,
                            py: 1,
                            background: 'linear-gradient(90deg, #f2674a 0%, #ffbf00 100%)',
                            color: '#fff',
                            fontWeight: 600,
                            textTransform: 'none',
                            fontSize: 16,
                            '&:hover': {
                              background: 'linear-gradient(90deg, #d55a3f 0%, #e6ac00 100%)',
                            }
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate('/boosterlending');
                          }}
                        >
                          Register Now
                        </Button>
                      </Box>
                    </>)
                }
                {!IsOnBoosterLoan && (
                  <>
                    <Box px={4} m='20px 0px 20px 0px'>
                      {isBuyActive ? (
                        <Button
                          onClick={() => { onBuyNow("Buy") }}
                          // disabled={isC2CRestricted}
                          variant="contained"
                          className="text-dark  fw-700 btn"
                          sx={{ fontSize: '16px', width: '100%', bgcolor: `${isBuyActive ? "#4edf6d !important" : "#FF2A2A !important"}`, padding: '10px !important' }}
                        >
                          {isBuyActive ? 'Buy Now' : 'Sell Now'}
                        </Button>
                      ) : (
                        (availabelQty > 0) && (
                          <Button
                            onClick={() => { onBuyNow("Sell") }}
                            // disabled={isC2CRestricted}
                            variant="contained"
                            className="text-dark  fw-700 btn"
                            sx={{ fontSize: '16px', width: '100%', bgcolor: `${isBuyActive ? "#4edf6d !important" : "#FF2A2A !important"}`, padding: '10px !important' }}
                          >
                            {isBuyActive ? 'Buy Now' : 'Sell Now'}
                          </Button>
                        )
                      )}
                    </Box>
                  </>
                )}
              </>
            </>
          }
        </CardContent>
      </Card>
      {loading && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          bgcolor="rgba(0, 0, 0, 0.5)" // Semi-transparent black background
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{
            backdropFilter: "blur(5px)", // Blur effect
            zIndex: 9999, // Ensures the loader stays above all elements
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      )}
      <OrderSuccessPopup
        open={popupOpen}
        // onClose={() => setPopupOpen(false)}
        onClose={() => {
          setPopupOpen(false);
          fetchTradingBalance();
        }}
        orderDetails={orderDetails}
        onboardingType={assetType}
      />
      {showPopup && <Successpopup Heading={heading} Success={Success} onClose={closePopup} Message={msg} />}

      {/* OTP Modal */}
      <Modal open={otpModalOpen} onClose={() => setOtpModalOpen(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: '#181A20', // dark theme background
          boxShadow: '0 8px 32px 0 rgba(34, 34, 34, 0.37)',
          p: { xs: 2, sm: 4 },
          borderRadius: 4,
          minWidth: { xs: 320, sm: 400 },
          maxWidth: '90vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          border: '1px solid #23272F',
        }}>
          <Typography variant="h5" mb={1.5} sx={{ color: '#f2674a', fontWeight: 700, letterSpacing: 1 }}>Verify Transaction</Typography>
          <Typography mb={3} sx={{ color: '#fff', fontSize: '16px', textAlign: 'center', fontWeight: 400 }}>
            Enter the 6-digit OTP sent to your registered email to confirm your crypto order.
          </Typography>
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            inputType="tel"
            shouldAutoFocus
            containerStyle={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
              gap: '18px',
              marginBottom: '18px',
            }}
            inputStyle={{
              width: '48px',
              height: '56px',
              fontSize: '24px',
              border: `2px solid ${otpError ? '#ff2a2a' : '#23272F'}`,
              borderRadius: '12px',
              textAlign: 'center',
              background: '#23272F',
              color: '#fff',
              fontWeight: 600,
              outline: 'none',
              transition: 'border-color 0.2s',
            }}
            renderInput={(props) => (
              <input
                {...props}
                className="otp"
                onKeyDown={(e: React.KeyboardEvent) => {
                  if (e.key === "Enter") {
                    handleOtpSubmit();
                  } else if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                    e.preventDefault();
                  }
                }}
              />
            )}
          />
          {otpError && <Typography color="error" mt={1} sx={{ fontWeight: 500 }}>{otpError}</Typography>}
          <Button
            variant="contained"
            sx={{
              mt: 2,
              minWidth: 160,
              borderRadius: '30px',
              fontWeight: 700,
              fontSize: '18px',
              background: 'linear-gradient(90deg, #f2674a 0%, #ffbf00 100%)',
              color: '#fff',
              boxShadow: '0 2px 8px rgba(242, 103, 74, 0.15)',
              textTransform: 'none',
              '&:hover': {
                background: 'linear-gradient(90deg, #d55a3f 0%, #ffbf00 100%)',
                boxShadow: '0 4px 16px rgba(242, 103, 74, 0.25)',
              },
            }}
            onClick={handleOtpSubmit}
            disabled={otpLoading}
          >
            Confirm Order
          </Button>
          <Button
            variant="outlined"
            sx={{
              mt: 1.5,
              minWidth: 160,
              borderRadius: '30px',
              fontWeight: 700,
              fontSize: '18px',
              border: '2px solid #ff2a2a',
              color: '#ff2a2a',
              textTransform: 'none',
              background: 'transparent',
              boxShadow: 'none',
              '&:hover': {
                background: 'rgba(255, 42, 42, 0.1)',
                borderColor: '#d60000',
                color: '#d60000',
              },
            }}
            onClick={handleCancelOrder}
            disabled={otpLoading}
          >
            Cancel Order
          </Button>
          <Box mt={3} display="flex" flexDirection="column" alignItems="center" width="100%">
            <Typography sx={{ color: '#a3a3a3', fontSize: '14px', mb: 1 }}>
              Didn't receive the OTP?
            </Typography>
            <Button
              variant="text"
              sx={{
                color: '#f2674a',
                fontWeight: 700,
                fontSize: '15px',
                textTransform: 'none',
                borderRadius: '8px',
                background: 'none',
                '&:hover': {
                  background: 'none',
                  color: '#d55a3f',
                },
              }}
              onClick={resendOTP}
              disabled={otpLoading}
            >
              Resend OTP
            </Button>
          </Box>
        </Box>
      </Modal>

      <BoosterLoanReminderModal
        open={boosterLoanReminderOpen}
        onClose={() => setBoosterLoanReminderOpen(false)}
        dontRemind30Days={dontRemind30Days}
        setDontRemind30Days={setDontRemind30Days}
        handleNo={handleBoosterLoanReminderNo}
        handleYes={handleBoosterLoanReminderYes}
      // handleLearnMore={handleBoosterLoanReminderLearnMore}
      />
    </div>

  );
}

export default BuySell;
